module.exports = __webpack_public_path__ + "img/HT-M00.becbe98a.jpg";